<template>
  <el-dialog
      :title="title"
      :visible.sync="visible"
      center
      width="400px"
      @close="handlerCancel"
  >

    <el-form ref="form" :model="form" label-width="100px"	v-loading="loading">
		 <el-form-item label="获取时间">
		   <el-radio-group v-model="form.sync_type">
				 <el-radio :label="10" size="large">发货后12小时</el-radio>
				 <el-radio :label="20" size="large">签收后</el-radio>
			 </el-radio-group>
		 </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handlerCancel">取 消</el-button>
      <el-button type="primary" @click="handlerConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      form:{
      	sync_type: 10,
      },
      callback:null,
      title:'',
      func:null,
      assemble: null,
			loading: false
    }
  },
  mounted() {

  },
  methods: {
    open(title, func, assemble, callback){
      this.title = title;
      this.func = func;
      this.assemble = assemble;
      this.callback = callback;
      this.visible = true;
    },
    handlerConfirm(){
      this.func({
        data:this.assemble(this.value),
        success:(res)=>{
          this.callback(res);
          this.visible = false;
        },
      })
    },
    handlerCancel(){
      this.visible = false;
    },
  }
}
</script>

<style scoped>
.el-form{
	display: flex;
	gap: 10px;
	align-items: center;
	justify-content: center;
}
.el-input-group--append .el-input__inner{
	text-align: center;
}
</style>